// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate, useSearchParams } from 'react-router-dom';

// import axios from 'axios';
// import config from '../Common/Configurations/APIConfig';
// import { rexTechTheme } from '../Common/Theme';
// import { 
//   Lock, 
//   Key, 
//   Eye, 
//   EyeOff, 
//   CheckCircle,
//   AlertCircle,
//   ArrowLeft,
//   Mail
// } from 'lucide-react';

// export default function ResetPassword() {
//     const navigate = useNavigate();
//     const [searchParams] = useSearchParams();
//     const [values, setValues] = useState({ 
//         newPassword: '', 
//         confirmPassword: '' 
//     });
//     const [errors, setErrors] = useState({});
//     const [loading, setLoading] = useState(false);
//     const [status, setStatus] = useState(null); // null, 'success', or 'error'
//     const [message, setMessage] = useState('');
//     const [showPassword, setShowPassword] = useState(false);
//     const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//     const [email, setEmail] = useState('');
//     const [token, setToken] = useState('');

//     // Extract email and token from URL parameters
//     useEffect(() => {
//         const urlEmail = searchParams.get('email');
//         const urlToken = searchParams.get('token');
        
//         if (!urlEmail || !urlToken) {
//             setStatus('error');
//             setMessage('Invalid reset link. Please request a new password reset link.');
//             return;
//         }
        
//         setEmail(urlEmail);
//         setToken(urlToken);
//     }, [searchParams]);

//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         setValues(prev => ({ ...prev, [name]: value }));
//         // Clear field-specific errors when user types
//         if (errors[name]) {
//             setErrors(prev => ({ ...prev, [name]: '' }));
//         }
//     };

//     const validateForm = () => {
//         const newErrors = {};
        
//         // Password validation
//         if (!values.newPassword.trim()) {
//             newErrors.newPassword = 'New password is required';
//         } else if (values.newPassword.length < 8) {
//             newErrors.newPassword = 'Password must be at least 8 characters long';
//         } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(values.newPassword)) {
//             newErrors.newPassword = 'Password must contain uppercase, lowercase, and numbers';
//         }
        
//         // Confirm password validation
//         if (!values.confirmPassword.trim()) {
//             newErrors.confirmPassword = 'Please confirm your password';
//         } else if (values.newPassword !== values.confirmPassword) {
//             newErrors.confirmPassword = 'Passwords do not match';
//         }
        
//         setErrors(newErrors);
//         return Object.keys(newErrors).length === 0;
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();
        
//         if (!validateForm()) {
//             return;
//         }
        
//         setLoading(true);
//         setStatus(null);
//         setMessage('');
        
//         try {
//             const formData = {
//                 email: email,
//                 token: token,
//                 password: values.newPassword,
//                 confirmPassword: values.confirmPassword
//             };
            
//             const response = await axios.post(config.APIACTIVEURL+config.RESETPASSWORD, formData);
            
//             if (response.data.success) {
//                 setStatus('success');
//                 setMessage(response.data.message || 'Password reset successfully!');
                
//                 // Auto-redirect to login after 3 seconds
//                 setTimeout(() => {
//                     navigate('/');
//                 }, 3000);
//             } else {
//                 setStatus('error');
//                 setMessage(response.data.message || 'Password reset failed. Please try again.');
//             }
//         } catch (error) {
//             console.error("Reset password error:", error);
//             setStatus('error');
//             setMessage(
//                 error?.response?.data?.message || 
//                 error?.response?.data?.errors?.join(', ') || 
//                 'Failed to reset password. The link may have expired. Please request a new one.'
//             );
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Show loading state while extracting parameters
//     if (email === '' && token === '' && status === null) {
//         return (
//             <div style={{
//                 minHeight: '100vh',
//                 display: 'flex',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 backgroundColor: rexTechTheme.colors.neutral.lightGray
//             }}>
//                 <div style={{ textAlign: 'center' }}>
//                     <div style={{
//                         width: '40px',
//                         height: '40px',
//                         border: `3px solid ${rexTechTheme.colors.primary.main}`,
//                         borderTopColor: 'transparent',
//                         borderRadius: '50%',
//                         animation: 'spin 1s linear infinite',
//                         margin: '0 auto 16px'
//                     }} />
//                     <p style={{
//                         color: rexTechTheme.colors.neutral.darkGray,
//                         fontSize: rexTechTheme.typography.fontSize.regular
//                     }}>
//                         Loading reset password form...
//                     </p>
//                 </div>
//                 <style>{`
//                     @keyframes spin {
//                         0% { transform: rotate(0deg); }
//                         100% { transform: rotate(360deg); }
//                     }
//                 `}</style>
//             </div>
//         );
//     }

//     return (
//         <div style={{
//             minHeight: '100vh',
//             backgroundColor: rexTechTheme.colors.neutral.lightGray,
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             padding: rexTechTheme.spacing.xl,
//             fontFamily: rexTechTheme.typography.fontFamily
//         }}>
//             <div style={{
//                 width: '100%',
//                 maxWidth: '450px',
//                 backgroundColor: rexTechTheme.colors.neutral.white,
//                 padding: rexTechTheme.spacing.xxl,
//                 borderRadius: rexTechTheme.borderRadius.xlarge,
//                 boxShadow: rexTechTheme.shadows.medium,
//                 '@media (max-width: 768px)': {
//                     padding: rexTechTheme.spacing.xl
//                 }
//             }}>
//                 {/* Header */}
//                 <div style={{ textAlign: 'center', marginBottom: rexTechTheme.spacing.xl }}>
//                     <div style={{
//                         width: '60px',
//                         height: '60px',
//                         backgroundColor: rexTechTheme.colors.primary.lightest,
//                         borderRadius: rexTechTheme.borderRadius.round,
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         margin: '0 auto 16px',
//                         border: `2px solid ${rexTechTheme.colors.primary.light}`
//                     }}>
//                         <Key size={28} color={rexTechTheme.colors.primary.main} />
//                     </div>
//                     <h1 style={{
//                         margin: `0 0 ${rexTechTheme.spacing.sm} 0`,
//                         fontSize: rexTechTheme.typography.fontSize.xlarge,
//                         color: rexTechTheme.colors.primary.dark,
//                         fontWeight: 600
//                     }}>
//                         Reset Password
//                     </h1>
//                     <p style={{
//                         margin: 0,
//                         color: rexTechTheme.colors.neutral.darkGray,
//                         fontSize: rexTechTheme.typography.fontSize.regular
//                     }}>
//                         Enter your new password for 
//                         <strong style={{ marginLeft: '4px' }}>{email}</strong>
//                     </p>
//                 </div>

//                 {/* Status Messages */}
//                 {status === 'error' && (
//                     <div style={{
//                         padding: rexTechTheme.spacing.md,
//                         backgroundColor: rexTechTheme.colors.accent.lightest,
//                         border: `1px solid ${rexTechTheme.colors.accent.orange}`,
//                         borderRadius: rexTechTheme.borderRadius.medium,
//                         color: rexTechTheme.colors.accent.orange,
//                         marginBottom: rexTechTheme.spacing.lg,
//                         display: 'flex',
//                         alignItems: 'center',
//                         gap: rexTechTheme.spacing.sm
//                     }}>
//                         <AlertCircle size={18} />
//                         <div>{message}</div>
//                     </div>
//                 )}
                
//                 {status === 'success' ? (
//                     // Success State
//                     <div style={{ textAlign: 'center' }}>
//                         <div style={{
//                             width: '80px',
//                             height: '80px',
//                             backgroundColor: rexTechTheme.colors.primary.lightest,
//                             borderRadius: rexTechTheme.borderRadius.round,
//                             display: 'flex',
//                             alignItems: 'center',
//                             justifyContent: 'center',
//                             margin: '0 auto 20px',
//                             border: `2px solid ${rexTechTheme.colors.primary.light}`
//                         }}>
//                             <CheckCircle size={36} color={rexTechTheme.colors.primary.main} />
//                         </div>
//                         <h2 style={{
//                             margin: `0 0 ${rexTechTheme.spacing.sm} 0`,
//                             fontSize: rexTechTheme.typography.fontSize.large,
//                             color: rexTechTheme.colors.primary.dark,
//                             fontWeight: 600
//                         }}>
//                             Password Reset Successful!
//                         </h2>
//                         <p style={{
//                             margin: `0 0 ${rexTechTheme.spacing.lg} 0`,
//                             color: rexTechTheme.colors.neutral.darkGray,
//                             fontSize: rexTechTheme.typography.fontSize.regular
//                         }}>
//                             {message}
//                         </p>
//                         <p style={{
//                             margin: `0 0 ${rexTechTheme.spacing.xl} 0`,
//                             color: rexTechTheme.colors.neutral.darkGray,
//                             fontSize: rexTechTheme.typography.fontSize.small
//                         }}>
//                             Redirecting to login page...
//                         </p>
//                         <Link 
//                             to="/" 
//                             style={{
//                                 display: 'block',
//                                 padding: `${rexTechTheme.spacing.md} ${rexTechTheme.spacing.xl}`,
//                                 backgroundColor: rexTechTheme.colors.primary.main,
//                                 color: rexTechTheme.colors.neutral.white,
//                                 borderRadius: rexTechTheme.borderRadius.medium,
//                                 textDecoration: 'none',
//                                 fontWeight: 600,
//                                 fontSize: rexTechTheme.typography.fontSize.regular,
//                                 transition: 'all 0.3s ease',
//                                 ':hover': {
//                                     backgroundColor: rexTechTheme.colors.primary.dark,
//                                     transform: 'translateY(-2px)',
//                                     boxShadow: rexTechTheme.shadows.button
//                                 }
//                             }}
//                         >
//                             Go to Login
//                         </Link>
//                     </div>
//                 ) : (
//                     // Reset Password Form
//                     <form onSubmit={handleSubmit} autoComplete="off" noValidate>
//                         {/* New Password Field */}
//                         <div style={{ marginBottom: rexTechTheme.spacing.lg }}>
//                             <label style={{
//                                 display: 'block',
//                                 marginBottom: rexTechTheme.spacing.xs,
//                                 color: rexTechTheme.colors.primary.dark,
//                                 fontWeight: 600,
//                                 fontSize: rexTechTheme.typography.fontSize.regular
//                             }}>
//                                 New Password
//                             </label>
//                             <div style={{ position: 'relative' }}>
//                                 <Lock 
//                                     size={20} 
//                                     style={{
//                                         position: 'absolute',
//                                         left: rexTechTheme.spacing.md,
//                                         top: '50%',
//                                         transform: 'translateY(-50%)',
//                                         color: rexTechTheme.colors.neutral.darkGray,
//                                         pointerEvents: 'none'
//                                     }}
//                                 />
//                                 <input
//                                     type={showPassword ? "text" : "password"}
//                                     name="newPassword"
//                                     value={values.newPassword}
//                                     onChange={handleInputChange}
//                                     style={{
//                                         width: '100%',
//                                         padding: `${rexTechTheme.spacing.md} ${rexTechTheme.spacing.md} ${rexTechTheme.spacing.md} 48px`,
//                                         border: `2px solid ${errors.newPassword ? rexTechTheme.colors.accent.orange : rexTechTheme.colors.neutral.gray}`,
//                                         borderRadius: rexTechTheme.borderRadius.medium,
//                                         fontSize: rexTechTheme.typography.fontSize.regular,
//                                         transition: 'all 0.2s ease',
//                                         outline: 'none',
//                                         boxSizing: 'border-box',
//                                         ':focus': {
//                                             borderColor: rexTechTheme.colors.primary.main,
//                                             boxShadow: `0 0 0 3px ${rexTechTheme.colors.primary.lightest}`
//                                         }
//                                     }}
//                                     placeholder="Enter new password"
//                                     required
//                                     disabled={loading}
//                                 />
//                                 <button
//                                     type="button"
//                                     onClick={() => setShowPassword(!showPassword)}
//                                     style={{
//                                         position: 'absolute',
//                                         right: rexTechTheme.spacing.md,
//                                         top: '50%',
//                                         transform: 'translateY(-50%)',
//                                         background: 'none',
//                                         border: 'none',
//                                         color: rexTechTheme.colors.neutral.darkGray,
//                                         cursor: 'pointer',
//                                         padding: '4px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         ':hover': {
//                                             color: rexTechTheme.colors.primary.main
//                                         }
//                                     }}
//                                     disabled={loading}
//                                 >
//                                     {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                                 </button>
//                             </div>
//                             {errors.newPassword && (
//                                 <div style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: rexTechTheme.spacing.xs,
//                                     marginTop: rexTechTheme.spacing.xs,
//                                     color: rexTechTheme.colors.accent.orange,
//                                     fontSize: rexTechTheme.typography.fontSize.small
//                                 }}>
//                                     <AlertCircle size={14} />
//                                     <span>{errors.newPassword}</span>
//                                 </div>
//                             )}
//                             <div style={{
//                                 marginTop: rexTechTheme.spacing.xs,
//                                 color: rexTechTheme.colors.neutral.darkGray,
//                                 fontSize: rexTechTheme.typography.fontSize.small
//                             }}>
//                                 Must be at least 8 characters with uppercase, lowercase, and numbers
//                             </div>
//                         </div>

//                         {/* Confirm Password Field */}
//                         <div style={{ marginBottom: rexTechTheme.spacing.xl }}>
//                             <label style={{
//                                 display: 'block',
//                                 marginBottom: rexTechTheme.spacing.xs,
//                                 color: rexTechTheme.colors.primary.dark,
//                                 fontWeight: 600,
//                                 fontSize: rexTechTheme.typography.fontSize.regular
//                             }}>
//                                 Confirm New Password
//                             </label>
//                             <div style={{ position: 'relative' }}>
//                                 <Lock 
//                                     size={20} 
//                                     style={{
//                                         position: 'absolute',
//                                         left: rexTechTheme.spacing.md,
//                                         top: '50%',
//                                         transform: 'translateY(-50%)',
//                                         color: rexTechTheme.colors.neutral.darkGray,
//                                         pointerEvents: 'none'
//                                     }}
//                                 />
//                                 <input
//                                     type={showConfirmPassword ? "text" : "password"}
//                                     name="confirmPassword"
//                                     value={values.confirmPassword}
//                                     onChange={handleInputChange}
//                                     style={{
//                                         width: '100%',
//                                         padding: `${rexTechTheme.spacing.md} ${rexTechTheme.spacing.md} ${rexTechTheme.spacing.md} 48px`,
//                                         border: `2px solid ${errors.confirmPassword ? rexTechTheme.colors.accent.orange : rexTechTheme.colors.neutral.gray}`,
//                                         borderRadius: rexTechTheme.borderRadius.medium,
//                                         fontSize: rexTechTheme.typography.fontSize.regular,
//                                         transition: 'all 0.2s ease',
//                                         outline: 'none',
//                                         boxSizing: 'border-box',
//                                         ':focus': {
//                                             borderColor: rexTechTheme.colors.primary.main,
//                                             boxShadow: `0 0 0 3px ${rexTechTheme.colors.primary.lightest}`
//                                         }
//                                     }}
//                                     placeholder="Confirm new password"
//                                     required
//                                     disabled={loading}
//                                 />
//                                 <button
//                                     type="button"
//                                     onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                                     style={{
//                                         position: 'absolute',
//                                         right: rexTechTheme.spacing.md,
//                                         top: '50%',
//                                         transform: 'translateY(-50%)',
//                                         background: 'none',
//                                         border: 'none',
//                                         color: rexTechTheme.colors.neutral.darkGray,
//                                         cursor: 'pointer',
//                                         padding: '4px',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         justifyContent: 'center',
//                                         ':hover': {
//                                             color: rexTechTheme.colors.primary.main
//                                         }
//                                     }}
//                                     disabled={loading}
//                                 >
//                                     {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
//                                 </button>
//                             </div>
//                             {errors.confirmPassword && (
//                                 <div style={{
//                                     display: 'flex',
//                                     alignItems: 'center',
//                                     gap: rexTechTheme.spacing.xs,
//                                     marginTop: rexTechTheme.spacing.xs,
//                                     color: rexTechTheme.colors.accent.orange,
//                                     fontSize: rexTechTheme.typography.fontSize.small
//                                 }}>
//                                     <AlertCircle size={14} />
//                                     <span>{errors.confirmPassword}</span>
//                                 </div>
//                             )}
//                         </div>

//                         {/* Submit Button */}
//                         <button
//                             type="submit"
//                             disabled={loading}
//                             style={{
//                                 width: '100%',
//                                 padding: rexTechTheme.spacing.lg,
//                                 background: `linear-gradient(135deg, ${rexTechTheme.colors.primary.main} 0%, ${rexTechTheme.colors.primary.light} 100%)`,
//                                 color: rexTechTheme.colors.neutral.white,
//                                 border: 'none',
//                                 borderRadius: rexTechTheme.borderRadius.medium,
//                                 fontSize: rexTechTheme.typography.fontSize.regular,
//                                 fontWeight: 600,
//                                 cursor: loading ? 'not-allowed' : 'pointer',
//                                 transition: 'all 0.3s ease',
//                                 opacity: loading ? 0.7 : 1,
//                                 boxShadow: rexTechTheme.shadows.button,
//                                 ':hover': {
//                                     background: `linear-gradient(135deg, ${rexTechTheme.colors.primary.dark} 0%, ${rexTechTheme.colors.primary.main} 100%)`,
//                                     transform: loading ? 'none' : 'translateY(-2px)',
//                                     boxShadow: loading ? rexTechTheme.shadows.button : rexTechTheme.shadows.medium
//                                 }
//                             }}
//                         >
//                             {loading ? (
//                                 <>
//                                     <div style={{
//                                         width: '20px',
//                                         height: '20px',
//                                         border: `2px solid ${rexTechTheme.colors.neutral.white}`,
//                                         borderTopColor: 'transparent',
//                                         borderRadius: '50%',
//                                         animation: 'spin 1s linear infinite',
//                                         display: 'inline-block',
//                                         marginRight: '8px'
//                                     }} />
//                                     Resetting Password...
//                                 </>
//                             ) : (
//                                 'Reset Password'
//                             )}
//                         </button>

//                         {/* Back to Login Link */}
//                         <div style={{
//                             marginTop: rexTechTheme.spacing.xl,
//                             textAlign: 'center'
//                         }}>
//                             <Link 
//                                 to="/" 
//                                 style={{
//                                     color: rexTechTheme.colors.primary.main,
//                                     textDecoration: 'none',
//                                     fontSize: rexTechTheme.typography.fontSize.regular,
//                                     display: 'inline-flex',
//                                     alignItems: 'center',
//                                     gap: rexTechTheme.spacing.xs,
//                                     ':hover': {
//                                         textDecoration: 'underline'
//                                     }
//                                 }}
//                             >
//                                 <ArrowLeft size={16} />
//                                 Back to Sign In
//                             </Link>
//                         </div>
//                     </form>
//                 )}

//                 {/* Footer */}
//                 <div style={{
//                     marginTop: rexTechTheme.spacing.xl,
//                     paddingTop: rexTechTheme.spacing.lg,
//                     borderTop: `1px solid ${rexTechTheme.colors.neutral.gray}`,
//                     textAlign: 'center',
//                     color: rexTechTheme.colors.neutral.darkGray,
//                     fontSize: rexTechTheme.typography.fontSize.small
//                 }}>
//                     <p style={{ margin: 0 }}>
//                         © 2024 RexTech. All rights reserved.
//                     </p>
//                 </div>
//             </div>
//         </div>
//     );
// }

import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import config from '../Common/Configurations/APIConfig';
import { rexTechTheme } from '../Common/Theme';
import { 
  Lock, 
  Key, 
  Eye, 
  EyeOff, 
  CheckCircle,
  AlertCircle,
  ArrowLeft
} from 'lucide-react';

export default function ResetPassword() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [values, setValues] = useState({ 
        newPassword: '', 
        confirmPassword: '' 
    });
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null); // null, 'success', or 'error'
    const [message, setMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [email, setEmail] = useState('');
    const [token, setToken] = useState('');

    // Extract email and token from URL parameters with proper encoding handling
    useEffect(() => {
        const extractParams = () => {
            try {
                // Get email from searchParams (this is safe)
                const urlEmail = searchParams.get('email');
                
                // Get the FULL URL
                const currentUrl = window.location.href;
                const urlObj = new URL(currentUrl);
                
                // Extract token manually to preserve URL encoding
                const paramsString = urlObj.search;
                const urlParams = new URLSearchParams(paramsString);
                
                // Get the raw token value
                let rawToken = urlParams.get('token');
                
                if (!urlEmail || !rawToken) {
                    throw new Error('Missing required parameters');
                }
                
                // Check if token needs encoding
                // If token contains characters that should be encoded but aren't, encode them
                if (rawToken.includes('/') && !rawToken.includes('%2F')) {
                    // Token appears to be decoded, re-encode it
                    rawToken = encodeURIComponent(rawToken);
                } else if (rawToken.includes('+') && !rawToken.includes('%2B')) {
                    // Handle plus signs
                    rawToken = encodeURIComponent(rawToken);
                }
                
                setEmail(urlEmail);
                setToken(rawToken);
                
            } catch (error) {
                console.error('Error extracting parameters:', error);
                setStatus('error');
                setMessage('Invalid reset link. Please request a new password reset link.');
            }
        };
        
        extractParams();
    }, [searchParams]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues(prev => ({ ...prev, [name]: value }));
        // Clear field-specific errors when user types
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const validateForm = () => {
        const newErrors = {};
        
        // Password validation
        if (!values.newPassword.trim()) {
            newErrors.newPassword = 'New password is required';
        } else if (values.newPassword.length < 8) {
            newErrors.newPassword = 'Password must be at least 8 characters long';
        } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(values.newPassword)) {
            newErrors.newPassword = 'Password must contain uppercase, lowercase, and numbers';
        }
        
        // Confirm password validation
        if (!values.confirmPassword.trim()) {
            newErrors.confirmPassword = 'Please confirm your password';
        } else if (values.newPassword !== values.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) {
            return;
        }
        
        setLoading(true);
        setStatus(null);
        setMessage('');
        
        try {
            // Ensure token is properly URL encoded for backend
            const encodedToken = token || '';
            
            // Debug logging
            console.log('Email:', email);
            console.log('Token (before sending):', encodedToken);
            console.log('Token length:', encodedToken.length);
            
            const formData = {
                email: email,
                token: encodedToken, // Send already URL-encoded token
                password: values.newPassword,
                confirmPassword: values.confirmPassword
            };
            
            console.log('Sending form data:', { 
                ...formData, 
                token: encodedToken.substring(0, 50) + '...' 
            });
            
            const response = await axios.post(
                config.APIACTIVEURL + config.RESETPASSWORD, 
                formData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );
            
            if (response.data.success) {
                setStatus('success');
                setMessage(response.data.message || 'Password reset successfully!');
                
                // Auto-redirect to login after 3 seconds
                setTimeout(() => {
                    navigate('/');
                }, 3000);
            } else {
                setStatus('error');
                setMessage(response.data.message || 'Password reset failed. Please try again.');
            }
        } catch (error) {
            console.error("Reset password error:", error);
            
            // Detailed error logging
            if (error.response) {
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);
                console.error("Response headers:", error.response.headers);
            }
            
            let errorMessage = 'Failed to reset password. Please try again.';
            
            if (error.response?.data?.message) {
                errorMessage = error.response.data.message;
            } else if (error.response?.data?.errors) {
                errorMessage = Array.isArray(error.response.data.errors) 
                    ? error.response.data.errors.join(', ')
                    : String(error.response.data.errors);
            } else if (error.message === 'Network Error') {
                errorMessage = 'Network error. Please check your connection.';
            }
            
            setStatus('error');
            setMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    // Show loading state while extracting parameters
    if (email === '' && token === '' && status === null) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: rexTechTheme.colors.neutral.lightGray
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        border: `3px solid ${rexTechTheme.colors.primary.main}`,
                        borderTopColor: 'transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto 16px'
                    }} />
                    <p style={{
                        color: rexTechTheme.colors.neutral.darkGray,
                        fontSize: rexTechTheme.typography.fontSize.regular
                    }}>
                        Loading reset password form...
                    </p>
                </div>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        );
    }

    // Show error if parameters are missing
    if (status === 'error' && (!email || !token)) {
        return (
            <div style={{
                minHeight: '100vh',
                backgroundColor: rexTechTheme.colors.neutral.lightGray,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: rexTechTheme.spacing.xl,
                fontFamily: rexTechTheme.typography.fontFamily
            }}>
                <div style={{
                    width: '100%',
                    maxWidth: '450px',
                    backgroundColor: rexTechTheme.colors.neutral.white,
                    padding: rexTechTheme.spacing.xxl,
                    borderRadius: rexTechTheme.borderRadius.xlarge,
                    boxShadow: rexTechTheme.shadows.medium,
                    textAlign: 'center'
                }}>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        backgroundColor: rexTechTheme.colors.accent.lightest,
                        borderRadius: rexTechTheme.borderRadius.round,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 16px',
                        border: `2px solid ${rexTechTheme.colors.accent.orange}`
                    }}>
                        <AlertCircle size={28} color={rexTechTheme.colors.accent.orange} />
                    </div>
                    <h1 style={{
                        margin: `0 0 ${rexTechTheme.spacing.sm} 0`,
                        fontSize: rexTechTheme.typography.fontSize.xlarge,
                        color: rexTechTheme.colors.primary.dark,
                        fontWeight: 600
                    }}>
                        Invalid Reset Link
                    </h1>
                    <p style={{
                        margin: `0 0 ${rexTechTheme.spacing.lg} 0`,
                        color: rexTechTheme.colors.neutral.darkGray,
                        fontSize: rexTechTheme.typography.fontSize.regular
                    }}>
                        {message || 'The reset link is invalid or has expired.'}
                    </p>
                    <Link 
                        to="/forgot-password" 
                        style={{
                            display: 'inline-block',
                            padding: `${rexTechTheme.spacing.md} ${rexTechTheme.spacing.xl}`,
                            backgroundColor: rexTechTheme.colors.primary.main,
                            color: rexTechTheme.colors.neutral.white,
                            borderRadius: rexTechTheme.borderRadius.medium,
                            textDecoration: 'none',
                            fontWeight: 600,
                            fontSize: rexTechTheme.typography.fontSize.regular,
                            transition: 'all 0.3s ease',
                            marginBottom: rexTechTheme.spacing.md,
                            ':hover': {
                                backgroundColor: rexTechTheme.colors.primary.dark,
                                transform: 'translateY(-2px)',
                                boxShadow: rexTechTheme.shadows.button
                            }
                        }}
                    >
                        Request New Reset Link
                    </Link>
                    <div style={{ marginTop: rexTechTheme.spacing.md }}>
                        <Link 
                            to="/" 
                            style={{
                                color: rexTechTheme.colors.primary.main,
                                textDecoration: 'none',
                                fontSize: rexTechTheme.typography.fontSize.regular,
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: rexTechTheme.spacing.xs,
                                ':hover': {
                                    textDecoration: 'underline'
                                }
                            }}
                        >
                            <ArrowLeft size={16} />
                            Back to Sign In
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            backgroundColor: rexTechTheme.colors.neutral.lightGray,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: rexTechTheme.spacing.xl,
            fontFamily: rexTechTheme.typography.fontFamily
        }}>
            <div style={{
                width: '100%',
                maxWidth: '450px',
                backgroundColor: rexTechTheme.colors.neutral.white,
                padding: rexTechTheme.spacing.xxl,
                borderRadius: rexTechTheme.borderRadius.xlarge,
                boxShadow: rexTechTheme.shadows.medium,
                '@media (max-width: 768px)': {
                    padding: rexTechTheme.spacing.xl
                }
            }}>
                {/* Header */}
                <div style={{ textAlign: 'center', marginBottom: rexTechTheme.spacing.xl }}>
                    <div style={{
                        width: '60px',
                        height: '60px',
                        backgroundColor: rexTechTheme.colors.primary.lightest,
                        borderRadius: rexTechTheme.borderRadius.round,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 16px',
                        border: `2px solid ${rexTechTheme.colors.primary.light}`
                    }}>
                        <Key size={28} color={rexTechTheme.colors.primary.main} />
                    </div>
                    <h1 style={{
                        margin: `0 0 ${rexTechTheme.spacing.sm} 0`,
                        fontSize: rexTechTheme.typography.fontSize.xlarge,
                        color: rexTechTheme.colors.primary.dark,
                        fontWeight: 600
                    }}>
                        Reset Password
                    </h1>
                    <p style={{
                        margin: 0,
                        color: rexTechTheme.colors.neutral.darkGray,
                        fontSize: rexTechTheme.typography.fontSize.regular
                    }}>
                        Enter your new password for 
                        <strong style={{ marginLeft: '4px' }}>{email}</strong>
                    </p>
                </div>

                {/* Status Messages */}
                {status === 'error' && (
                    <div style={{
                        padding: rexTechTheme.spacing.md,
                        backgroundColor: rexTechTheme.colors.accent.lightest,
                        border: `1px solid ${rexTechTheme.colors.accent.orange}`,
                        borderRadius: rexTechTheme.borderRadius.medium,
                        color: rexTechTheme.colors.accent.orange,
                        marginBottom: rexTechTheme.spacing.lg,
                        display: 'flex',
                        alignItems: 'center',
                        gap: rexTechTheme.spacing.sm
                    }}>
                        <AlertCircle size={18} />
                        <div style={{ flex: 1 }}>{message}</div>
                    </div>
                )}
                
                {status === 'success' ? (
                    // Success State
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            width: '80px',
                            height: '80px',
                            backgroundColor: rexTechTheme.colors.primary.lightest,
                            borderRadius: rexTechTheme.borderRadius.round,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            margin: '0 auto 20px',
                            border: `2px solid ${rexTechTheme.colors.primary.light}`
                        }}>
                            <CheckCircle size={36} color={rexTechTheme.colors.primary.main} />
                        </div>
                        <h2 style={{
                            margin: `0 0 ${rexTechTheme.spacing.sm} 0`,
                            fontSize: rexTechTheme.typography.fontSize.large,
                            color: rexTechTheme.colors.primary.dark,
                            fontWeight: 600
                        }}>
                            Password Reset Successful!
                        </h2>
                        <p style={{
                            margin: `0 0 ${rexTechTheme.spacing.lg} 0`,
                            color: rexTechTheme.colors.neutral.darkGray,
                            fontSize: rexTechTheme.typography.fontSize.regular
                        }}>
                            {message}
                        </p>
                        <p style={{
                            margin: `0 0 ${rexTechTheme.spacing.xl} 0`,
                            color: rexTechTheme.colors.neutral.darkGray,
                            fontSize: rexTechTheme.typography.fontSize.small
                        }}>
                            Redirecting to login page...
                        </p>
                        <Link 
                            to="/" 
                            style={{
                                display: 'block',
                                padding: `${rexTechTheme.spacing.md} ${rexTechTheme.spacing.xl}`,
                                backgroundColor: rexTechTheme.colors.primary.main,
                                color: rexTechTheme.colors.neutral.white,
                                borderRadius: rexTechTheme.borderRadius.medium,
                                textDecoration: 'none',
                                fontWeight: 600,
                                fontSize: rexTechTheme.typography.fontSize.regular,
                                transition: 'all 0.3s ease',
                                ':hover': {
                                    backgroundColor: rexTechTheme.colors.primary.dark,
                                    transform: 'translateY(-2px)',
                                    boxShadow: rexTechTheme.shadows.button
                                }
                            }}
                        >
                            Go to Login
                        </Link>
                    </div>
                ) : (
                    // Reset Password Form
                    <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                        {/* New Password Field */}
                        <div style={{ marginBottom: rexTechTheme.spacing.lg }}>
                            <label style={{
                                display: 'block',
                                marginBottom: rexTechTheme.spacing.xs,
                                color: rexTechTheme.colors.primary.dark,
                                fontWeight: 600,
                                fontSize: rexTechTheme.typography.fontSize.regular
                            }}>
                                New Password
                            </label>
                            <div style={{ position: 'relative' }}>
                                <Lock 
                                    size={20} 
                                    style={{
                                        position: 'absolute',
                                        left: rexTechTheme.spacing.md,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: rexTechTheme.colors.neutral.darkGray,
                                        pointerEvents: 'none'
                                    }}
                                />
                                <input
                                    type={showPassword ? "text" : "password"}
                                    name="newPassword"
                                    value={values.newPassword}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: `${rexTechTheme.spacing.md} ${rexTechTheme.spacing.md} ${rexTechTheme.spacing.md} 48px`,
                                        border: `2px solid ${errors.newPassword ? rexTechTheme.colors.accent.orange : rexTechTheme.colors.neutral.gray}`,
                                        borderRadius: rexTechTheme.borderRadius.medium,
                                        fontSize: rexTechTheme.typography.fontSize.regular,
                                        transition: 'all 0.2s ease',
                                        outline: 'none',
                                        boxSizing: 'border-box',
                                        ':focus': {
                                            borderColor: rexTechTheme.colors.primary.main,
                                            boxShadow: `0 0 0 3px ${rexTechTheme.colors.primary.lightest}`
                                        }
                                    }}
                                    placeholder="Enter new password"
                                    required
                                    disabled={loading}
                                    autoComplete="new-password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: rexTechTheme.spacing.md,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        color: rexTechTheme.colors.neutral.darkGray,
                                        cursor: 'pointer',
                                        padding: '4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        ':hover': {
                                            color: rexTechTheme.colors.primary.main
                                        }
                                    }}
                                    disabled={loading}
                                    aria-label={showPassword ? "Hide password" : "Show password"}
                                >
                                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                </button>
                            </div>
                            {errors.newPassword && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: rexTechTheme.spacing.xs,
                                    marginTop: rexTechTheme.spacing.xs,
                                    color: rexTechTheme.colors.accent.orange,
                                    fontSize: rexTechTheme.typography.fontSize.small
                                }}>
                                    <AlertCircle size={14} />
                                    <span>{errors.newPassword}</span>
                                </div>
                            )}
                            <div style={{
                                marginTop: rexTechTheme.spacing.xs,
                                color: rexTechTheme.colors.neutral.darkGray,
                                fontSize: rexTechTheme.typography.fontSize.small
                            }}>
                                Must be at least 8 characters with uppercase, lowercase, and numbers
                            </div>
                        </div>

                        {/* Confirm Password Field */}
                        <div style={{ marginBottom: rexTechTheme.spacing.xl }}>
                            <label style={{
                                display: 'block',
                                marginBottom: rexTechTheme.spacing.xs,
                                color: rexTechTheme.colors.primary.dark,
                                fontWeight: 600,
                                fontSize: rexTechTheme.typography.fontSize.regular
                            }}>
                                Confirm New Password
                            </label>
                            <div style={{ position: 'relative' }}>
                                <Lock 
                                    size={20} 
                                    style={{
                                        position: 'absolute',
                                        left: rexTechTheme.spacing.md,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: rexTechTheme.colors.neutral.darkGray,
                                        pointerEvents: 'none'
                                    }}
                                />
                                <input
                                    type={showConfirmPassword ? "text" : "password"}
                                    name="confirmPassword"
                                    value={values.confirmPassword}
                                    onChange={handleInputChange}
                                    style={{
                                        width: '100%',
                                        padding: `${rexTechTheme.spacing.md} ${rexTechTheme.spacing.md} ${rexTechTheme.spacing.md} 48px`,
                                        border: `2px solid ${errors.confirmPassword ? rexTechTheme.colors.accent.orange : rexTechTheme.colors.neutral.gray}`,
                                        borderRadius: rexTechTheme.borderRadius.medium,
                                        fontSize: rexTechTheme.typography.fontSize.regular,
                                        transition: 'all 0.2s ease',
                                        outline: 'none',
                                        boxSizing: 'border-box',
                                        ':focus': {
                                            borderColor: rexTechTheme.colors.primary.main,
                                            boxShadow: `0 0 0 3px ${rexTechTheme.colors.primary.lightest}`
                                        }
                                    }}
                                    placeholder="Confirm new password"
                                    required
                                    disabled={loading}
                                    autoComplete="new-password"
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    style={{
                                        position: 'absolute',
                                        right: rexTechTheme.spacing.md,
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        background: 'none',
                                        border: 'none',
                                        color: rexTechTheme.colors.neutral.darkGray,
                                        cursor: 'pointer',
                                        padding: '4px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        ':hover': {
                                            color: rexTechTheme.colors.primary.main
                                        }
                                    }}
                                    disabled={loading}
                                    aria-label={showConfirmPassword ? "Hide password" : "Show password"}
                                >
                                    {showConfirmPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                </button>
                            </div>
                            {errors.confirmPassword && (
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: rexTechTheme.spacing.xs,
                                    marginTop: rexTechTheme.spacing.xs,
                                    color: rexTechTheme.colors.accent.orange,
                                    fontSize: rexTechTheme.typography.fontSize.small
                                }}>
                                    <AlertCircle size={14} />
                                    <span>{errors.confirmPassword}</span>
                                </div>
                            )}
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                width: '100%',
                                padding: rexTechTheme.spacing.lg,
                                background: `linear-gradient(135deg, ${rexTechTheme.colors.primary.main} 0%, ${rexTechTheme.colors.primary.light} 100%)`,
                                color: rexTechTheme.colors.neutral.white,
                                border: 'none',
                                borderRadius: rexTechTheme.borderRadius.medium,
                                fontSize: rexTechTheme.typography.fontSize.regular,
                                fontWeight: 600,
                                cursor: loading ? 'not-allowed' : 'pointer',
                                transition: 'all 0.3s ease',
                                opacity: loading ? 0.7 : 1,
                                boxShadow: rexTechTheme.shadows.button,
                                ':hover': {
                                    background: `linear-gradient(135deg, ${rexTechTheme.colors.primary.dark} 0%, ${rexTechTheme.colors.primary.main} 100%)`,
                                    transform: loading ? 'none' : 'translateY(-2px)',
                                    boxShadow: loading ? rexTechTheme.shadows.button : rexTechTheme.shadows.medium
                                }
                            }}
                        >
                            {loading ? (
                                <>
                                    <div style={{
                                        width: '20px',
                                        height: '20px',
                                        border: `2px solid ${rexTechTheme.colors.neutral.white}`,
                                        borderTopColor: 'transparent',
                                        borderRadius: '50%',
                                        animation: 'spin 1s linear infinite',
                                        display: 'inline-block',
                                        marginRight: '8px'
                                    }} />
                                    Resetting Password...
                                </>
                            ) : (
                                'Reset Password'
                            )}
                        </button>

                        {/* Back to Login Link */}
                        <div style={{
                            marginTop: rexTechTheme.spacing.xl,
                            textAlign: 'center'
                        }}>
                            <Link 
                                to="/" 
                                style={{
                                    color: rexTechTheme.colors.primary.main,
                                    textDecoration: 'none',
                                    fontSize: rexTechTheme.typography.fontSize.regular,
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: rexTechTheme.spacing.xs,
                                    ':hover': {
                                        textDecoration: 'underline'
                                    }
                                }}
                            >
                                <ArrowLeft size={16} />
                                Back to Sign In
                            </Link>
                        </div>
                    </form>
                )}

                {/* Footer */}
                <div style={{
                    marginTop: rexTechTheme.spacing.xl,
                    paddingTop: rexTechTheme.spacing.lg,
                    borderTop: `1px solid ${rexTechTheme.colors.neutral.gray}`,
                    textAlign: 'center',
                    color: rexTechTheme.colors.neutral.darkGray,
                    fontSize: rexTechTheme.typography.fontSize.small
                }}>
                    <p style={{ margin: 0 }}>
                        © 2024 RexTech. All rights reserved.
                    </p>
                </div>
            </div>
            
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}